import { render, staticRenderFns } from "./TransferenciaPosseDefinitivaPasso3.vue?vue&type=template&id=bfe37e20&lang=html&"
import script from "./TransferenciaPosseDefinitivaPasso3.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseDefinitivaPasso3.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPosseDefinitivaPasso3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso3.vue
// module id = 1587
// module chunks = 28